export default __webpack_public_path__ + "static/media/dictionary.fc22d326.PNG";